export default class EnrollmentBroker {
  id: string;
  agency_id?: string;
}
